export default "__VITE_ASSET__DSuu_JLm__"